import * as yup from 'yup'

import { emailRegex } from '../regex'

export const validationSignInSchema = yup.object({
  email: yup.string().required('Email is a required field.')
    .matches(emailRegex, 'Should have a valid format (allows ".", "-" and "_")'),
  password: yup.string().required('No password provided.')
})
